module.exports = __webpack_public_path__ + "media/slider/Banner-4-457fd522.jpg";